import { fetchHTML } from '@utils';
import { pubsub } from '@services';

class CollectionGrid extends HTMLElement {
  abortController;

  connectedCallback() {
    this.unsubscribeSortChanged = pubsub.subscribe('sort:changed', () => this.handleSortChange());
    this.unsubscribeFiltersUpdated = pubsub.subscribe('filters:updated', () =>
      this.handleSortChange()
    );

    // Both the filter drawer and the quick-filter chips move the customer
    // through the collection with pushState, so Back changes the URL without
    // reloading. Republishing here re-renders the grid *and* the drawer, which
    // is subscribed to the same event. (NGE-11501)
    this.onPopState = () => pubsub.publish('filters:updated');
    window.addEventListener('popstate', this.onPopState);
  }

  disconnectedCallback() {
    this.unsubscribeSortChanged();
    this.unsubscribeFiltersUpdated();
    window.removeEventListener('popstate', this.onPopState);
  }

  /**
   * Handle sort change
   */
  async handleSortChange() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const searchParams = new URLSearchParams(window.location.search);

    try {
      const html = await fetchHTML(
        `${window.location.pathname}?section_id=main-collection&${searchParams}`
      );

      this.renderProductGrid(html);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Render product grid
   * @param {HTMLElement} html - HTML to render
   */
  renderProductGrid(html) {
    const parsedCollectionGrid = html.querySelector('collection-grid');

    this.innerHTML = parsedCollectionGrid.innerHTML;

    // The results count sits in the sticky filter bar, outside this element, so
    // an AJAX render left "10 prodotti" standing over a grid of 9. The fetch is
    // already section-wide, so the fresh count came back with it. (NGE-11501)
    const parsedCount = html.querySelector('.plp-results-count');
    const count = document.querySelector('.plp-results-count');
    if (parsedCount && count) count.innerHTML = parsedCount.innerHTML;

    // Remove loading state from price elements after DOM update
    setTimeout(() => {
      this.querySelectorAll('.price.loading').forEach((priceElement) => {
        priceElement.classList.remove('loading');
      });
    }, 50);
  }
}

customElements.define('collection-grid', CollectionGrid);
